<script>
    import Image from '@project/components/Image.svelte'
    import { spring } from 'svelte/motion'
    import { tick } from 'svelte'
    import { dim } from '@project/utils'

    let urlPrefix = "/roxerdigital/404/";

    const { w, h } = dim()

    let el, point, outer
    let side = 0.3
    let o = 0.8
    let x3, y3, x4, y4


    let c = spring({
        x1: -20,
        x2: -40,
        y2: h * o,
        x3: -100,
        y3: h * 0.5,
        x4: -40,
        y4: h * (1 - o),
        x5: -20,
        y5: h,
        y6: h,
    }, {
        stiffness: 0.1,
        damping: 0.5
    })

    const load = (e) => {
        el = e.detail
        finalCalc(e.detail)
    }

    const resize = () => {
        if (el) {
            finalCalc(el)
        }
    }

    const finalCalc = (element) => {
        calcPolygon(element)
    }

    const scroll = () => {
        if (el && x3 && y3) {
            calcOuter(el, x3, y3)
        }
    }

    const calcOuter = async (element, xx, yy) => {
        await tick()
        const { top, left, width, height } = element.getBoundingClientRect()

        const x = xx - (left + width)
        const y = yy - (top + height)

        outer.style.transform = `translateY(${y}px) translateX(${x}px)`
    }



    const calcPolygon = async (element) => {
        await tick()

        const { w, h } = dim()
        const { top, left, width, height } = element.getBoundingClientRect()

        x3 = point.offsetLeft + point.offsetWidth + (width - 30)
        y3 = h * 0.5
        x4 = w * 0.1
        y4 = h * 0.7
        c.set({
            x1: w * side,
            x2: w * 0.1,
            y2: h * 0.3,
            x3,
            y3,
            x4,
            y4,
            x5: w * side,
            y5: h,
            y6: h,
        })

        calcOuter(element, x3, y3)
    }
</script>
<svelte:head>
    <style>
        html,
        body {
            height: 100%;
        }
    </style>
</svelte:head>
<svelte:window on:resize={resize}></svelte:window>

<main class="h-full flex flex-col justify-between">
    <svg class="fixed -z-1 overflow-hidden" height="100%" width="100%">
        <path
            d="M 0 0 L {$c.x1} 0 L {$c.x2} {$c.y2} L {$c.x3} {$c.y3} L {$c.x4} {$c.y4} L {$c.x5} {$c.y5} L 0 {$c.y6} L 0 0"
            style="fill:#222;" />
    </svg>

    <section
        class="px-3 flex justify-center items-center h-full w-full text-center text-xl leading-relaxed text-roxerblack uppercase">
        <aside class="pr-12">
            <img alt="404" bind:this={point} class="relative z-10 ml-6" src="{urlPrefix}media/kermit_404.svg">
        </aside>
        <article bind:this={outer}>
            <p class="text-left ml-16 sm:ml-20 text-base sm:text-lg sm:text-2xl uppercase">
                Ez gyors volt, <b>csak</b> <br> sajnos pontatlan.
            </p>
            <div class="w-full md:w-4/5 max-w-2xl my-12">
                <Image on:load={load} height="280" jpg="{urlPrefix}media/Kermit_poster.jpg" mp4="{urlPrefix}media/Kermit_404.mp4" webm="{urlPrefix}media/Kermit_404.webm" />
            </div>
            <p class="text-left ml-16 sm:ml-20 pt-16 sm:pt-32 md:pt-20 text-base sm:text-lg sm:text-2xl uppercase">
                Próbáld meg <br>
                <b>lassabban</b>, <br>
                hátha az lesz nyerő.
            </p>
        </article>
    </section>
    <footer class="text-center pb-4 mt-8">
        <a class="inline-block" href="https://roxer.hu/">
            <img alt="A Roxer logója" class="w-8 md:w-12" src="{urlPrefix}media/roxer_logo_dark.png">
        </a>
    </footer>
</main>

<style>
    .img {
        max-width: 5em;
    }
</style>